import React, { ContextType } from 'react';
import { RootStore } from '.';
import { useMemo } from 'react';

export const StoreContext = React.createContext<RootStore | undefined>(undefined);

/** Create new RootStore instance and provide it through context */
export const StoreProvider: React.FC = ({ children }) => {
  const store = useMemo(() => new RootStore(), []);
  return <StoreContext.Provider value={store}>{children}</StoreContext.Provider>;
};

function isRootStore(value: unknown): value is RootStore {
  return value instanceof RootStore;
}

/** Access RootStore */
export const useStore = () => {
  const store = React.useContext(StoreContext);
  if (!isRootStore(store)) {
    // this is especially useful in TypeScript so you don't need to be checking for null all the time
    throw new Error('useStore must be used within a StoreProvider.');
  }
  return store;
};

/** Ensures that RootStore in context value is not empty */
export function getStoreFromContext(context: ContextType<typeof StoreContext>): RootStore {
  if (isRootStore(context)) {
    return context;
  }
  throw new Error('Context value not instance of RootStore. Use StoreProvider?');
}
